/* DON'T EDIT THIS FILE: edit original and run build again */ export const canViewOpinionReportSection = "canViewOpinionReportSection";
export const canViewInitialDocumentsSection = "canViewInitialDocumentsSection";
export const canViewPresentationOpinionReportSection =
  "canViewPresentationOpinionReportSection";
export const canViewFullInfoOpinionReportSection =
  "canViewFullInfoOpinionReportSection";
export const canSetExpirationDate = "canSetExpirationDate";
export const canEditOpinionReportSection = "canEditOpinionReportSection";
export const canSubmitOthersContainers = "canSubmitOthersContainers";
